export default __webpack_public_path__ + "static/media/aakav.02d7b9ca.jpg";